import script from "./AbilityTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./AbilityTooltip.vue?vue&type=script&setup=true&lang=js"

import "./AbilityTooltip.vue?vue&type=style&index=0&id=466ef27a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466ef27a"]])

export default __exports__